export default __webpack_public_path__ + "static/media/logo_b@2x.03203cca.png";